export class InlineIdError extends Error {
    constructor(message) {
        super(message);
        this.name = "InlineIdError";
    }
}
export const asInlineId = (value, fieldName = "id") => {
    if (typeof value === "bigint")
        return value;
    if (typeof value !== "number") {
        throw new InlineIdError(`invalid ${fieldName}: expected number|bigint`);
    }
    if (!Number.isSafeInteger(value)) {
        throw new InlineIdError(`invalid ${fieldName}: number must be a safe integer`);
    }
    return BigInt(value);
};
